// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.charge-row td[data-v-15092272] {\n\tborder-bottom: 1px solid #eee;\n\tcolor: #666;\n\tfont-size: 12px;\n\tpadding-top: 4px;\n\tpadding-bottom: 4px;\n}\n.charge-reason[data-v-15092272] {\n\tfont-style: italic;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
